import { atomFamily } from 'jotai-family';
import { atomWithDefault } from 'jotai/utils';
import { INewsDataModel } from '../../data-models/news.data-model';
import { fetchCompanyNews } from '../queries/MaggieCompanyQueries';

export const newsByCompanyIdState = atomFamily((companyId: number) =>
  atomWithDefault<INewsDataModel[] | Promise<INewsDataModel[]>>(() => fetchCompanyNews(companyId))
);
